import { TimePicker } from '@mui/x-date-pickers';
import { useField } from 'formik';
import React from 'react';

// Formik-bound MUI X TimePicker for storing an integer hour-of-day
// (0–23) in the form value.  Internally converts to/from a Date so
// MUI's pickers can render properly; only the hour is persisted.
//
// Pass `views={['hours','minutes']}` to allow minute granularity
// (defaults to hour-only since the only consumer today is
// alarm-report email delivery time, which is hour-resolution).
export default function SettingsTimePickerField({
  name,
  label,
  views = ['hours'],
  helperText,
  hiddenLabel = false,
  ...rest
}) {
  const [field, meta, helpers] = useField(name);
  const showError = Boolean(meta.touched && meta.error);

  const date = React.useMemo(() => {
    const d = new Date();
    d.setHours(Number(field.value) || 0, 0, 0, 0);
    return d;
  }, [field.value]);

  return (
    <TimePicker
      {...rest}
      label={hiddenLabel ? undefined : label}
      value={date}
      onChange={value => {
        if (!value) return;
        helpers.setValue(value.getHours());
      }}
      views={views}
      slotProps={{
        textField: {
          variant: 'filled',
          hiddenLabel,
          fullWidth: true,
          name,
          error: showError,
          helperText: showError ? meta.error : helperText,
        },
      }}
    />
  );
}
